module.exports = __webpack_public_path__ + "img/11.930eb7e4.png";